import React from "react";
import urlJoin from "url-join";
import { useTheme } from "../features/theme";

interface BrandLogoProps {
  className?: string;
  onClick?: () => void;
  alt?: string;
}

/**
 * The Composo wordmark. The gradient chat-mark reads on any ground, but the
 * wordmark is a solid colour, so we swap to a light-wordmark asset in dark mode
 * (both live in /public). Centralised here so every logo placement — sidebar,
 * login, loader, 404, small-screen guard — adapts from one place.
 */
export function BrandLogo({
  className,
  onClick,
  alt = "Composo logo",
}: BrandLogoProps) {
  const { resolvedTheme } = useTheme();
  const asset = resolvedTheme === "dark" ? "/logo-dark.svg" : "/logo.svg";
  return (
    <img
      src={urlJoin(import.meta.env.BASE_URL, asset)}
      className={className}
      alt={alt}
      onClick={onClick}
    />
  );
}
